import { DecimalFormat } from "@omni/types/components/price/enums/decimalFormat.enum";

import { Translate } from "@/redux/modules/value/translations/translations.provider";

export const splitPrice = (price: number, fractionDigits = 2) =>
    price.toFixed(fractionDigits).toString().split(".");

type FormatPrice = (
    price?: number,
    formatOptions?: {
        currency?: boolean;
        decimal?: DecimalFormat;
    } & (
        | {
              freeLabel?: false;
          }
        | {
              freeLabel: true;
              t: Translate;
          }
    )
) => string;

export const formatPrice: FormatPrice = (price = 0, formatOptions = {}) => {
    const {
        currency = false,
        decimal = DecimalFormat.Default,
        ...freeProps
    } = formatOptions;

    if (freeProps.freeLabel && price === 0) {
        return freeProps.t("general.product.free");
    }

    let formatted = price.toFixed(2).toString().replace(".", ",");

    if (currency) {
        formatted = `€${formatted}`;
    }

    if (decimal === DecimalFormat.Dash) {
        formatted = formatted
            // replace trailing zeros after a comma with dash
            .replace(/,0+$/, ",-");
    } else if (decimal === DecimalFormat.Hidden) {
        formatted = formatted
            // remove trailing zeros after a comma
            .replace(/,0+$/, "");
    }

    return formatted;
};

export function formatPriceNoRounding(price = 0, fractionDigits = 2) {
    return (
        parseInt(`${price * 10 ** fractionDigits}`, 10) /
        10 ** fractionDigits
    ).toFixed(fractionDigits);
}
